import { enumToOptions } from "../blocks/fields/enumToOptions";
import { EntityAuditType } from "../config/enums";
import { getEntityFriendlyName } from "../utils/entityFriendlyName";
import { getPageAllowedRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const operationOptions = enumToOptions(EntityAuditType);

// The entities the warehouse writes audits for.
const auditedEntities = ["dwautomation", "warehouseapplication", "warehouseconfiguration"];

const entityOptions = auditedEntities
  .map((entity) => ({
    Key: entity,
    Value: getEntityFriendlyName(entity),
  }))
  .sort((a, b) => a.Value.localeCompare(b.Value));

/**
 * The entity audits list. Paged by the search endpoint and read on arrival. Audits are
 * only read, so there is no record page of their own: the name opens the audited record.
 */
export const entityAuditsListDefinition: ListDefinition = {
  path: "/entity-audits",
  entityName: "entityaudit",
  title: "Entity Audits",
  allowedRoles: getPageAllowedRoles("entity-audits"),
  data: "search-paged",
  searchOnLoad: true,
  // Lower case: the repository reads this key from a case-sensitive dictionary.
  filters: [
    {
      name: "type",
      label: "Operation",
      kind: "picklist",
      options: operationOptions,
    },
    {
      name: "entityname",
      label: "Entity",
      kind: "picklist",
      options: entityOptions,
      width: "wider",
    },
    {
      name: "emailaddress",
      label: "User",
      kind: "picklist",
      optionsFrom: "portal-users",
      width: "wider",
    },
    { name: "createdon", label: "Date", kind: "date-range", advanced: true },
  ],
  filterByStatus: false,
  allowAdd: false,
  allowStatusEdit: false,
  defaultSortKey: "createdon",
  defaultSortDir: "desc",
  pageSize: 50,
  columns: [
    {
      key: "label",
      label: "Name",
      width: 300,
      sortable: true,
      link: { entityKey: "entityname", idKey: "entityid", newTab: "button" },
    },
    {
      key: "type",
      label: "Operation",
      width: 200,
      sortable: true,
      display: "picklist",
      options: operationOptions,
    },
    {
      key: "entityname",
      label: "Entity",
      width: 200,
      sortable: true,
      display: "entity-name",
    },
    {
      key: "emailaddress",
      label: "User",
      width: 300,
      sortable: true,
      display: "lowercase",
    },
    {
      key: "createdon",
      label: "Date",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
